import { EventValueDto, FrameworkAgreementType } from "../../../../../autogen/bff-api";

export type ValueJudgedBy = "estimate" | "maximum";

export interface ThresholdValue {
  value: number | null;
  judgedBy: ValueJudgedBy;
}

interface ValuedContext {
  estimatedValue?: EventValueDto | null;
  frameworkAgreement?: FrameworkAgreementType | null;
  frameworkMaximumValue?: EventValueDto | null;
}

// Mirrors the BFF's FoaPartClassifier.valueJudgedAgainstThresholds (FOA § 5-4 (5), forsyningsforskriften § 5-3 (5)).
export const valueJudgedAgainstThresholds = (context: ValuedContext | null | undefined): ThresholdValue => {
  const estimate = context?.estimatedValue?.value ?? null;
  const maximum = context?.frameworkMaximumValue?.value ?? null;
  const isFramework = context?.frameworkAgreement != null && context.frameworkAgreement !== FrameworkAgreementType.None;
  if (!isFramework || maximum == null || (estimate != null && estimate >= maximum)) {
    return { value: estimate, judgedBy: "estimate" };
  }
  return { value: maximum, judgedBy: "maximum" };
};
